import GetFlowService from '../Services/GetFlowService'

const GetFlow = (flow) => {
    return GetFlowService(flow)
        .then(data => {
            return data;
        })
        .catch(error => {
            return error;
        });
}

export default GetFlow